
import ExampleBranchItem from "./ExampleBranchItem.jsx"

export default function ExampleBranchesPage({data, theme}) {
  const deployExampleBranches = ()=>{
    return data.branches.map((item, inx)=>{
      return <ExampleBranchItem key={`exampleBranchesItem_inx_${inx}`} item={item} index={inx} theme={theme}/>
    })
  }
  return (
    <div className='exampleBranchesPage' style={{backgroundColor:`${theme.secondary_color}`}}>
      <h3 className="exampleBranchesPage_header" style={{textShadow:`2px 2px 4px ${theme.primary_color}`, color:`${theme.accent_color}`}}>הסניפים שלנו</h3>
      <div className="exampleBranchesPage_list">
        {deployExampleBranches()}
      </div>
    </div>
  )
}
